import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Admin } from '~/features/admin/types/admin.type';

/**
 * 관리자 상세 조회
 * @description 특정 관리자의 상세 정보를 조회합니다
 * @endpoint GET /admin/admins/{id}
 * @param id - 관리자 ID
 * @returns 관리자 상세 정보
 */
export function getAdminApi(id: number) {
  return axiosInstance.get<ApiResponse<Admin>>(`/admin/admins/${id}`);
}
